import { LoggingChannels, LoggingService } from '../logging/logging.service';
import { NotificationService } from '../notification/notification.service';

export class VBQualityController {
  public fps: number;
  public resolution: number;
  public savedResolution: number;
  public forceResolution: boolean;
  public lastDecrease: number;

  constructor(
    private logging: LoggingService,
    private notification: NotificationService,
    private isActiveGetter: () => boolean,
    private resetIntervalCallback: () => void,
    private syncResolution: (resolution: number) => void,
  ) {}

  public upgrade(): void {
    if (this.isActiveGetter()) {
      if (this.forceResolution) {
        return;
      }
      const now = (new Date()).getTime();
      if (this.resolution === 0.75 && this.fps === 24) {
        return;
      }
      if (now - this.lastDecrease < 30000) {
        return;
      }
      this.lastDecrease = now;
      if (this.fps === 18) {
        this.fps = 24;
        this.resetIntervalCallback();
      } else if (this.fps === 24) {
        this.resolution = this.resolution + 0.25;
        this.syncResolution(this.resolution);
        this.resetIntervalCallback();
      }
      this.logging.log('VirtualBackgroundService: upgrade', LoggingChannels.Remediation, this.resolution, this.fps);
    }
  }

  public downgrade(): boolean {
    if (this.isActiveGetter()) {
      if (this.forceResolution) {
        return false;
      }
      const now = (new Date()).getTime();
      if (this.resolution === 0.25 && this.fps === 18) {
        this.lastDecrease = now;
        return false;
      }
      if (now - this.lastDecrease < 5000) {
        return true;
      }
      this.lastDecrease = now;
      if (this.fps === 18) {
        this.fps = 24;
        this.resolution = this.resolution - 0.25;
        this.syncResolution(this.resolution);
        this.resetIntervalCallback();
      } else if (this.fps === 24) {
        this.fps = 18;
        this.resetIntervalCallback();
        if (this.resolution === 0.25 && this.fps === 18) {
          this.notification.display('problems.background', 'warning', 'top', 5000, [{
            side: 'end',
            icon: 'close',
            role: 'cancel',
          }]);
        }
      }
      this.logging.log('VirtualBackgroundService: downgrade', LoggingChannels.Remediation, this.resolution, this.fps);
      return true;
    }
    return false;
  }
}
